module.exports = __webpack_public_path__ + "fonts/88e3166a132095ec8c846f11dac4f61a.woff";